import React from 'react';
import d3 from 'd3';
const getBarWidth = (data,axis,scale,barspace,groupspace,props) => {
    let seriesarray = data.map((obj) => obj.series);
    let xseriesarray=seriesarray.map((arr1) => arr1.map((arr2) => arr2[axis]));
    let xpixelarray = xseriesarray.map((arr1) => arr1.map((arr2) => scale(arr2)));
    let xdiffarray = xpixelarray.map(arr => arrayToDiffs(arr));
    let mindiffarr = xdiffarray.map(arr => Math.min(...arr));
    let mindiff = Math.min(...mindiffarr);
    if(mindiff==Infinity) {
        if(axis == 0) {
            mindiff = props.width - props.paddingRight - props.paddingLeft
        } else {
            mindiff = props.height - props.paddingTop - props.paddingBottom
        }
    }
    if(props.stacked) {
        return (mindiff - groupspace);
    } else {
        return ((mindiff - groupspace) - barspace * (mindiffarr.length - 1))/seriesarray.length;
    }
}
const arrayToDiffs= (arr) => arr.reduce((prev,cur,idx,arr) => idx>0?[...prev,cur-arr[idx-1]]:[],[]);
const seriesToBars = (data,width,offset,xScale,yScale,seriesindex,superkey,labelsWithBars,horz,props) => {
    if(typeof horz === "undefined") {
        horz=false;
    }
    if(!horz) {
        return data.series.map((point,i) => <g key={superkey+"_"+"bar"+i}><rect 
            x={xScale(point[0])+offset}
            y={point[1]>=0?yScale(point[1]):yScale(0)}
            dy={props.stacked?yScale(point[2]):0}
            width={Math.ceil(width)}
            height={Math.abs(yScale(point[1])-yScale(0))}
            fill={data.color}
        />{labelsWithBars?(<foreignObject
            x={xScale(point[0])+offset}
            y={point[1]>=0?yScale(0):yScale(point[1])}
            dy={props.stacked?yScale(point[2]):0}
            width={width}
            height="200"
        ><div className="barlabel">{data.name}</div></foreignObject>):null}</g>)
    } else {
        

        return data.series.map((point,i) => <g key={superkey+"_"+"bar"+i} className="barcontainer"><rect 
                x={(point[0]>=0?xScale(0):xScale(point[0])) + (props.stacked?(xScale(point[2])-xScale(0)):0)}
                y={props.reverseYAxis?(yScale(point[1])+offset):(yScale(point[1])-offset-width)}
                width={Math.abs(xScale(point[0])-xScale(0))}
                height={Math.ceil(width)}
                fill={data.color}
            />
            {labelsWithBars?(<foreignObject
                x={0}
                y={props.reverseYAxis?(yScale(point[1])+offset):(yScale(point[1])-offset-width)}
                width={point[0]>=0?xScale(0):xScale(point[0])}
                height={width}
            ><div className="barlabel-horz">
                <div className="barlabel-horz-inner">
                    <span>{data.name}</span>
                </div>
            </div></foreignObject>):null}
            {props.valuesOnBars?(<text
                x={xScale(point[0]) + (props.stacked?(xScale(point[2])-xScale(0)):0)}
                y={props.reverseYAxis?(yScale(point[1])+offset+width/2):(yScale(point[1])-offset-width/2)}
                className="innerValue"
                dx="-6px"
                style={{
                    fill:"#ffffff",
                    fontWeight:700,
                    textAnchor:point[0]>0?"end":"start",
                    dominantBaseline:"middle",
                    visibility:"hidden"
                }}>{props.barNumberFormat?props.barNumberFormat(point[0],seriesindex,i):point[0]}</text>):null}
            {props.valuesOnBars?(<text
                x={xScale(point[0]) + (props.stacked?(xScale(point[2])-xScale(0)):0)}
                y={props.reverseYAxis?(yScale(point[1])+offset+width/2):(yScale(point[1])-offset-width/2)}
                dx="6px"
                className="outerValue"
                style={{
                    fill:"rgba(0, 0, 0, 0.87)",
                    fontWeight:600,
                    textAnchor:point[0]>0?"start":"end",
                    dominantBaseline:"middle",
                    visibility:"hidden"
                }}>{props.barNumberFormat?props.barNumberFormat(point[0],seriesindex,i):point[0]}</text>):null}
        </g>) 
    }
};

const addStackOffsets = function(data,axis) {
    
    let indep_array = data.map((obj) => obj.series.map((point) => point[axis]))
        .reduce((prev,cur) => [...prev,...cur],[]);
    //let dep_array = data.map((obj) => obj.series.map((point) => point[axis]))
    //    .reduce((prev,cur) => [...prev,...cur],[]);
    let unique_indep = indep_array.filter((val,i) => indep_array.indexOf(val)==i);
    let clonedata = JSON.parse(JSON.stringify(data));
    for(let val of unique_indep) {
        let accum = 0;
        clonedata.forEach(obj => {
            obj.series = obj.series.map(point => {
                if(point[axis]===val) {
                    point[2] = accum;
                    accum += point[axis^1]
                }
                return point;    
            })  
        });       
    }
    return clonedata;
}

export default class ChartBars extends React.Component {
    componentDidMount() {
        this.updateNumberVals(this.refs.bars);
    }
    componentDidUpdate() {
        this.updateNumberVals(this.refs.bars);
    }
    updateNumberVals(container) {
        if(!this.props.valuesOnBars) { return; }
        Array.from(container.querySelectorAll(".barcontainer")).forEach((barcontainer) => {
            let barwidth = barcontainer.querySelector("rect").getBBox().width;
            let innervalel = barcontainer.querySelector(".innerValue");
            let outervalel = barcontainer.querySelector(".outerValue");
            if((innervalel.getBBox().width+12)>barwidth) {
                outervalel.style.visibility="visible";
                innervalel.style.visibility="hidden";
            } else {
                innervalel.style.visibility="visible";
                outervalel.style.visibility="hidden";
            }
        });
        
    }
    render() {
        let props = this.props;
        const barWidth = getBarWidth(props.data,props.horizontal?1:0,props.horizontal?props.yScale:props.xScale,props.barSpacing,props.groupSpacing,props);
        let data = props.data;
            
        if(props.stacked) {
            if(props.horizontal) {
                data = addStackOffsets(props.data,1);        
            } else {
                data = addStackOffsets(props.data,0);
            }
        }
        
        return <g ref="bars">{data.map((series,i) => seriesToBars(
                series,
                barWidth,
                props.stacked?0:(i*(barWidth+props.barSpacing)),
                props.xScale,
                props.yScale,
                i,
                "barseries"+i,
                props.labelsWithBars,
                props.horizontal,
                props
            ))}</g>
    }
}


                
                


// WEBPACK FOOTER //
// ./src/js/components/charting/ChartBars/ChartBars.jsx